'use client'

import type { TextField } from '@payloadcms/plugin-form-builder/types'
import type { FieldErrorsImpl, FieldValues, UseFormRegister } from 'react-hook-form'

import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import React from 'react'

import { Error } from '../Error'
import { Width } from '../Width'
import { useFormFieldValue } from '../hooks/useFormFieldValue'
import { TypedLocale } from 'payload'

export const Number: React.FC<
  TextField & {
    errors: Partial<FieldErrorsImpl>
    register: UseFormRegister<FieldValues>
    locale: TypedLocale
  }
> = ({ name, defaultValue, errors, label, register, required, width, locale }) => {
  const [urlValue] = useFormFieldValue(name, defaultValue)
  return (
    <Width width={width}>
      <Label htmlFor={name}>
        {label}

        {required && (
          <span className="required">
            * <span className="sr-only">(required)</span>
          </span>
        )}
      </Label>
      <Input defaultValue={urlValue} id={name} type="number" {...register(name, { required })} />
      {errors[name] && <Error name={name} locale={locale} />}
    </Width>
  )
}
